// src/data/careersData.ts

import { CareersPageDetails } from "../types/CareersPageDetails";

export const careersPageData: CareersPageDetails = {
    mainTitle: 'Join Our Growing Family 🤝',
    
    description: `
        We're always looking for dedicated team members who share our commitment to service and quality. If you're interested in joining the SSA Retail Group Limited family, we'd love to hear from you. We offer competitive wages, benefits packages, and opportunities for professional growth within a supportive, community-focused environment.
    `,

    ctaButton: {
        text: 'Email Us Your CV',
        link: 'mailto:careers@ssaretailgrouplimited.co.uk',
    },
};